import usePost from '../usePost';
import {IUser, IUserRegisterParams} from './useUser';
import useGet from '../useGet';
import {IQueryByIdParams} from '../../utils/HttpInstance';
import {IQueryByBankIdParams} from './useKnowledgeBank';

export interface IKnowledgeQuestion {
  topic: string;
  id: number;
  serialNumber: number;
  createdTime: string;
  rightOptions: string[];
  wrongOptions: string[];
}

export default class UseKnowledgeQuestion {
  static listByBankId() {
    return useGet<IQueryByBankIdParams, IKnowledgeQuestion[]>('knowledgeQuestion/listByBankId', {});
  }
}
